/**
 * 웹뷰 쪽 사건을 활동 로그로 보낸다(저장 실패·화면 오류). MCP 종류(tool·bridge·session)는 Rust만 쓴다.
 * 사용자 본문(작업명·코멘트)은 넣지 않는다(A4).
 */
import { invoke, isDesktop } from "./runtime";

export interface ClientLogEntry {
  level: "debug" | "info" | "warn" | "error";
  type: "app" | "storage" | "file" | "error";
  action: string;
  summary?: string;
  status: "ok" | "fail" | "denied" | "timeout" | "busy";
  durationMs?: number;
  meta?: Record<string, string | number | boolean | null>;
}

let lastKey = "";
let lastAt = 0;
let burst = 0;

/** 같은 사건이 연달아 오면 1초에 5건까지만 보낸다(오류 폭주로 로그가 앱을 느리게 하지 않게). */
export function clientLog(entry: ClientLogEntry): void {
  if (!isDesktop()) return;
  const key = `${entry.type}:${entry.action}`;
  const now = Date.now();
  if (key === lastKey && now - lastAt < 1000) {
    burst++;
    if (burst > 5) return;
  } else {
    burst = 0;
  }
  lastKey = key;
  lastAt = now;
  void invoke("append_client_log", { entry }).catch(() => {});
}
